import React from 'react';
import { useOneButtonStore } from '../../../../store/oneButtonStore';
import FinancePartnerChecklistSection from './FinancePartnerChecklistSection';
import './oneButton-css/FinancePartnerSyncModal.css';
import './oneButton-css/CommerceHubPanel.css';

export interface CommerceHubPanelProps {
    salesForceId?: string | null | undefined;
    loading?: boolean;
    onSolarPricingClick?: () => void;
    opportunityNumericId?: string | number | null | undefined;
    priceQuote?: unknown;
}

/** Inline commerce hub (partner checklist). Modals live in `CommerceHubModals` (single dashboard mount). */
export const CommerceHubPanel: React.FC<CommerceHubPanelProps> = () => {
    const theme = useOneButtonStore((s) => s.theme);

    return (
        <div className={`obd-commerce-hub obd-theme-${theme}`}>
            <FinancePartnerChecklistSection />
        </div>
    );
};

export default CommerceHubPanel;
